import { render } from "./AdminFAQ.vue?vue&type=template&id=09cba14a&scoped=true"
import script from "./AdminFAQ.vue?vue&type=script&lang=js"
export * from "./AdminFAQ.vue?vue&type=script&lang=js"

import "./AdminFAQ.vue?vue&type=style&index=0&id=09cba14a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cba14a"]])

export default __exports__